import isNil from 'lodash/isNil'
import {
  GeckoMeasurement,
  GeckoMeasurementUnit,
  SpecificGravityProfileEnum,
} from 'types'
//this should just deal in meters - height and max height
export const interpolateGravity = (
  profileType: SpecificGravityProfileEnum | undefined,
  height: GeckoMeasurement | undefined, // Height for which gravity needs to be interpolated
  initialGravity: number | undefined, // initial gravity for a Linear profile
  maxHeight: GeckoMeasurement | undefined, // Maximum height for interpolation
  finalGravity: number = 1.0 // Default value for finalGravity
): number | undefined => {
  if (isNil(height) || isNil(initialGravity) || isNil(maxHeight)) {
    return undefined
  }
  const maxFillHeight = maxHeight.convertTo(GeckoMeasurementUnit.Feet)
  switch (profileType) {
    case SpecificGravityProfileEnum.Linear: {
      if (height.num <= 0) {
        return initialGravity
      }
      if (height.num >= maxFillHeight.num) {
        return 0
      }
      const ratio = height.num / maxFillHeight.num
      return initialGravity - ratio * (initialGravity - finalGravity)
    }

    default: {
      return initialGravity
    }
  }
}
